import { createStyles, Theme } from '@material-ui/core/styles';

const styles = ({ colors, spacing }: Theme) => createStyles({
  link: {
    display: 'inline-flex',
    alignItems: 'center',
    textDecoration: 'none',
    color: colors.controls.buttonText.enabled.name,

    '& span': {
      marginLeft: spacing(1),
    },

    '& path': {
      fill: colors.controls.buttonText.enabled.icon,
    },
  },
});

export default styles;
